import { Pagination } from "#components";
import { RowSkeleton, TableSkeleton } from "#skeleton";
import { NotFound } from "#UI";
import React from "react";

export default function TableLayout({
  isLoading,
  isEmpty,
  tableHeader,
  children,
  currentPage,
  onDataCountChange,
  totalItems, // You need to pass totalItems as a prop
  rowLimit,
  handlePrevPage,
  handleNextPage,
  pagination,
}) {
  // const [loading, setLoading] = React.useState(false);

  // React.useEffect(() => {
  //   setLoading(true);
  //   const timer = setTimeout(() => setLoading(false), 200);
  //   return () => clearTimeout(timer);
  // }, [isLoading]);

  if (isLoading) {
    return (
      <TableSkeleton tableHeader={tableHeader}>
        <RowSkeleton tableData={tableHeader} />;
      </TableSkeleton>
    );
  }

  if (isEmpty) {
    return <NotFound />;
  }

  return (
    <>
      {children}
      {pagination ? null : (
        <Pagination
          currentPage={currentPage}
          onDataCountChange={onDataCountChange}
          totalItems={totalItems}
          rowLimit={rowLimit}
          handlePrevPage={handlePrevPage}
          handleNextPage={handleNextPage}
        />
      )}
    </>
  );
}
